var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconDarkmode48Line = function SvgIconDarkmode48Line(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 40.7h-.4a16.59 16.59 0 0 1-12-5.46 16.93 16.93 0 0 1 .4-22.85 16.62 16.62 0 0 1 9.33-4.87 2.9 2.9 0 0 1 2.52 4.92A9.29 9.29 0 0 0 35.17 27a2.91 2.91 0 0 1 4.15 3.65 16.85 16.85 0 0 1-3.51 5.17A16.56 16.56 0 0 1 24 40.7Zm-3.6-29.5a13 13 0 0 0-6 3.56A13.48 13.48 0 0 0 14.16 33a13.3 13.3 0 0 0 21.37-2.32 12.71 12.71 0 0 1-7.18.91 12.69 12.69 0 0 1-7.94-20.39h-.01Z",
    fill: "current"
  })));
};
export default SvgIconDarkmode48Line;